import { useEffect, useRef } from 'react'

export function useTagDragging({
  draggingTagIndex,
  tags,
  duration,
  waveformRef,
  setTags,
  setDraggingTagIndex,
}) {
  const draggingTagIndexRef = useRef(null)
  const tagsRef = useRef(tags)
  const durationRef = useRef(duration)

  useEffect(() => {
    draggingTagIndexRef.current = draggingTagIndex
    tagsRef.current = tags
    durationRef.current = duration
  }, [draggingTagIndex, tags, duration])

  useEffect(() => {
    const handleMouseMove = (event) => {
      const index = draggingTagIndexRef.current
      if (index === null || !waveformRef.current || !durationRef.current) return
      const rect = waveformRef.current.getBoundingClientRect()
      const percent = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width))
      const currentTags = tagsRef.current
      const previousTime = index > 0 ? currentTags[index - 1].time + 0.5 : 0.5
      const nextTime = index < currentTags.length - 1
        ? currentTags[index + 1].time - 0.5
        : durationRef.current - 0.5
      const time = Math.max(previousTime, Math.min(nextTime, percent * durationRef.current))
      setTags((current) => {
        const next = [...current]
        next[index] = { ...next[index], time }
        return next
      })
    }
    const handleMouseUp = () => setDraggingTagIndex(null)
    window.addEventListener('mousemove', handleMouseMove)
    window.addEventListener('mouseup', handleMouseUp)
    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('mouseup', handleMouseUp)
    }
  }, [setDraggingTagIndex, setTags, waveformRef])
}
